import { render, staticRenderFns } from "./ArticleMobile.vue?vue&type=template&id=bdae6e1e&scoped=true"
import script from "./ArticleMobile.vue?vue&type=script&lang=js"
export * from "./ArticleMobile.vue?vue&type=script&lang=js"
import style0 from "./ArticleMobile.vue?vue&type=style&index=0&id=bdae6e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdae6e1e",
  null
  
)

export default component.exports